import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
	"inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
	{
		variants: {
			variant: {
				default:
					"border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
				secondary:
					"border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
				destructive:
					"border-transparent bg-destructive text-white shadow hover:bg-destructive/80",
				outline: "text-foreground",
				active:
					"border-transparent bg-[#1E9E6B]/10 text-[#1E9E6B]",
				pending:
					"border-[#c9a227]/30 bg-[#c9a227]/10 text-[#9a7b1e]",
				inactive:
					"border-slate-300 bg-slate-100 text-slate-600",
				info:
					"border-transparent bg-[#2d5a8a] text-white shadow-sm",
				success:
					"border-transparent bg-[#1E9E6B] text-white shadow-sm",
				warning:
					"border-transparent bg-[#c9a227] text-white shadow-sm",
				official:
					"border-transparent bg-gradient-to-r from-[#1e3a5f] to-[#2d5a8a] text-white shadow-sm font-semibold tracking-wide",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	}
)

export interface BadgeProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
	return (
		<div className={cn(badgeVariants({ variant }), className)} {...props} />
	)
}

export { Badge, badgeVariants }
